import { createSlice } from "@reduxjs/toolkit";

const initState = {
    reloadFireBase: '',
    LICH_KHAM_ID:'',
    bodyNotiFireBase:'',
};
//LOAD_THONG_TIN_KHAM_NHAN_CLS
const hosobenhanSlice = createSlice({
    name: "hosobenhan",
    initialState: initState,
    reducers: {
        setReloadFireBase(state, action) {
            state.reloadFireBase = action.payload;
        },
        setLICHKHAM_ID(state, action) {
            state.LICH_KHAM_ID = action.payload;
        },
        setNotiFireBase(state, action) {
            state.bodyNotiFireBase = action.payload;
        },
    },
});

export const {
  setReloadFireBase,
  setLICHKHAM_ID,
  setNotiFireBase
} = hosobenhanSlice.actions;
export const KhamBenhActions = hosobenhanSlice.actions;

export default hosobenhanSlice.reducer;
